import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  fullHeightCard: {
    height: '100%',
  },
  splitBox: {
    flex: '1 1 380px',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 'calc(50% - 12px)',
    },
  },
  courseBox: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
  },
  courseImage: {
    display: 'block',
  },
}))

export default useStyles
